/**
 * Shows a confirmation popup when a visitor's IP-detected country doesn't match the
 * market they're currently browsing (India <-> international). Fires once per
 * browser (localStorage-gated), regardless of which direction was shown.
 */
(function () {
  var STORAGE_KEY = 'brahm:geo-popup-seen';
  var COUNTRY_CACHE_KEY = 'brahm:geo-country';
  var COUNTRY_CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours — avoids re-hitting the geolocation API on every page view
  var GEO_ENDPOINT = 'https://ipwho.is/';
  var INDIA_CODE = 'IN';

  function readCachedCountry() {
    try {
      var cached = JSON.parse(localStorage.getItem(COUNTRY_CACHE_KEY));
      if (cached && Date.now() - cached.at < COUNTRY_CACHE_TTL) {
        return cached.code;
      }
    } catch (e) {}
    return null;
  }

  function writeCachedCountry(code) {
    try {
      localStorage.setItem(COUNTRY_CACHE_KEY, JSON.stringify({ code: code, at: Date.now() }));
    } catch (e) {}
  }

  function detectVisitorCountry() {
    var cached = readCachedCountry();
    if (cached) return Promise.resolve(cached);

    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 4000);

    return fetch(GEO_ENDPOINT, { signal: controller.signal })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var code = data && data.success !== false ? data.country_code : null;
        if (code) writeCachedCountry(code);
        return code;
      })
      .catch(function () { return null; })
      .finally(function () { clearTimeout(timeout); });
  }

  function init() {
    var config = window.BrahmGeoPopup;
    var popup = document.getElementById('geolocation-popup');

    if (!config || !popup || localStorage.getItem(STORAGE_KEY)) return;

    detectVisitorCountry().then(function (detected) {
      if (!detected) return;

      var visitorIsIndian = detected === INDIA_CODE;

      // Only show when there's a mismatch between the active market and the detected country.
      if (config.onIndiaMarket === visitorIsIndian) return;

      var direction = config.onIndiaMarket ? 'to-international' : 'to-india';
      popup.querySelectorAll('[data-geo-panel="to-india"]').forEach(function (el) {
        el.hidden = direction !== 'to-india';
      });
      popup.querySelectorAll('[data-geo-panel="to-international"]').forEach(function (el) {
        el.hidden = direction !== 'to-international';
      });

      if (direction === 'to-international') {
        var countryInput = document.getElementById('geolocation-popup__detected-country');
        if (countryInput) countryInput.value = detected;

        // Shopify's localization form defaults return_to to the current (India) URL, which would bounce the
        // visitor right back to /en-in after the market switch. Point it at the equivalent international path.
        var form = document.getElementById('geolocation-popup-form-to-international');
        var returnToInput = form && form.querySelector('input[name="return_to"]');
        if (returnToInput) {
          var strippedPath = window.location.pathname.replace(/^\/en-in\/?/, '/');
          returnToInput.value = strippedPath + window.location.search;
        }
      }

      customElements.whenDefined('x-modal').then(function () {
        popup.show();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('geolocation-popup');
    if (!popup) return;

    popup.addEventListener('dialog:after-hide', function () {
      localStorage.setItem(STORAGE_KEY, 'true');
    });

    var indiaForm = document.getElementById('geolocation-popup-form-to-india');
    if (indiaForm) {
      indiaForm.addEventListener('submit', function () {
        localStorage.setItem(STORAGE_KEY, 'true');
      });
    }

    var internationalForm = document.getElementById('geolocation-popup-form-to-international');
    if (internationalForm) {
      internationalForm.addEventListener('submit', function () {
        localStorage.setItem(STORAGE_KEY, 'true');
      });
    }

    setTimeout(init, (window.BrahmGeoPopup && window.BrahmGeoPopup.delay) || 0);
  });
})();
